
<template>
  <div class="check_box">
    <div class="item">
      <ul>
        <li><span>卡号&nbsp;&nbsp;</span><span class="cardNum">{{copyCard}}</span> <span class="copy_btn status"
                v-clipboard:copy="copyCard"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError">复制</span></li>
        <li><span>密码&nbsp;&nbsp;</span><span class="passWord">{{copyPass}}</span> <span class="copy_btn status"
                v-clipboard:copy="copyPass"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError">复制</span></li>
      </ul>
    </div>
    <div class="iframe">
      <iframe :src="src"
              frameborder="0"
              ref="iframe"
              id="bdIframe"></iframe>
    </div>
    <MessageInfo :propJson="propJson"
                 @sureClick="sureClick" />
  </div>
</template>

<script>
import MessageInfo from '@/components/messageInfo'
export default {
  components: {
    MessageInfo,
  },
  data () {
    return {
      propJson: {
        title: '提示',
        message: '获取卡密失败，请重试或联系客服',
        cacleBtn: '稍后查看',
        sureBtn: '刷新重试',
        showToast: false,
        isSecond: false,
      },
      src: 'http://demo.huacai189.com/',
      iframeWin: {},
      userInfo: {},
      id: '',
      copyCard: '11111',
      copyPass: '',
      iframeWin: null,
    }
  },
  mounted () {
    // 这里就拿到了iframe的对象
    console.log(this.$refs.iframe)
    // 这里就拿到了iframe的window对象
    console.log(this.$refs.iframe.contentWindow)
    /*  iframe-宽高自适应显示  */
    const oIframe = document.getElementById('bdIframe');
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.width = (Number(deviceWidth) - 0) + 'px'; //数字是页面布局宽度差值
    oIframe.style.height = (Number(deviceHeight) - 110) + 'px'; //数字是页面布局高度差
    this.id = this.$route.query.id;
    this.util.title('礼包详情');
    this.getGifs();
  },
  methods: {
    sureClick () {//刷新重试
      this.getGifs();
    },
    onCopy (e) {
      this.util.toast({ msg: '复制成功' })
    },
    onError (e) {
      this.util.toast({ msg: '复制失败' })
    },
    getGifs () {
      this.$post('/app/valueAdded/receiveGift/' + this.id, {})
        .then(res => {
          var e = res;
          if (e.code == 200) {
            this.copyCard = res.data.cardNum;
            this.copyPass = res.data.password;
          }
          else {
            this.propJson.showToast = true;
          }
        })
        .catch(error => { });
    },
  }

}
</script>
<style scoped>
.check_box {
  background: #f7f7f7;
  position: relative;
  top: 0;
}

.item {
  background: #fff;
  padding: 0.15rem;
  padding-bottom: 0;
  position: relative;
  top: -0.15rem;
  color: #333;
  font-size: 0.16rem;
}
.iframe {
  text-align: center;
}
.item .line {
  display: inline-block;
  margin-right: 0.1rem;
  width: 0.03rem;
  height: 0.12rem;
  background: rgba(81, 117, 241, 1);
}
.item ul li {
  border-bottom: 1px solid #eee;
  padding: 0.15rem 0;
}
.item ul li:last-child {
  border-bottom: 0;
}
.item .status {
  float: right;
  color: #4f8cfa;
  font-size: 0.14rem;
}
</style>
